// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bgp_a bhe_h","Menu__offsetParent":"bgp_b bhe_bj","Menu__trigger--shadowed":"bgp_c"};